import Vue from 'vue'
import axios from 'axios'
import store from '../store'
import {getLocalStorage, removeLocalStorage} from "./index";
import router from '../router'


let ajax =  axios.create({
  baseURL: process.env.BASE_URL,
  headers: {
    // 'Content-Type': 'application/json'
  },
  timeout: 100000,
  transformRequest: [function (data) {
    if (data instanceof FormData) {
      return data
    }
    return data
  }]
})

// 拦截请求
ajax.interceptors.request.use((config) => {
  const token = getLocalStorage(store.state.userToken)
  if (token){
    config.headers["HK-Aspire-Token"] = token
  }
  store.dispatch('fetchLoading', true)
  return config
}, error => {
  return Promise.reject(error)
})

// 拦截响应
ajax.interceptors.response.use(response => {
  store.dispatch('fetchLoading', false)
  return response
}, error => {
  store.dispatch('fetchLoading', false)
  if (!error.response.config.skipLogin && error.response.data.code.toString().startsWith('40')) {
    removeLocalStorage(store.state.userToken)
    removeLocalStorage(store.state.userInfo)
    router.push({name:'登录'})
  }
  return error.response
})

export default ajax



// WEBPACK FOOTER //
// ./src/utils/request.js